<template>
  <multi-selection-tool-button
    icon="mdi-checkbox-multiple-blank"
    :disabled="disabled"
    :tooltip="$t('InvertSelection')"
    @click="$emit('click')"
  />
</template>

<script>
import MultiSelectionToolButton from "@/components/Home/Forms/_Atoms/TableToolbarButton";

export default {
  name: "HomeFormTableSelectInvertTool",

  components: { MultiSelectionToolButton },

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/TableToolbarButtons/SelectInvert.vue